import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.178 1.874a8.303 8.303 0 0 1 6.377 13.618l5.35 5.352a.75.75 0 0 1-1.06 1.06l-5.35-5.351a8.303 8.303 0 1 1-5.317-14.679zm0 1.5a6.803 6.803 0 1 0-.002 13.605 6.803 6.803 0 0 0 .001-13.605zm-.053 2.25a.75.75 0 0 1 .75.75v3h3a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.75.75h-3v3a.75.75 0 0 1-.648.743l-.102.007a.75.75 0 0 1-.75-.75v-3h-3a.75.75 0 0 1-.743-.648l-.007-.102a.75.75 0 0 1 .75-.75h3v-3a.75.75 0 0 1 .648-.743z' />
  </svg>
);
